module.exports = __webpack_public_path__ + "static/media/Level2End.f454b7ac.mp4";